import React from 'react';
import {
    MemberSelectDialog as MemberSelectDialogBase,
    MemberSelectDialogProps
} from '@fx-ui/jdy-design-biz';
import ValueTag from '../value-tag';
import MemberName from '../member-name';
import { authModel } from '../../models';
import { tracker } from '../../utils';
import { TRACKER } from '../../constants';
import { join } from '@libs/shared';
import MemberAvatar from '../member-avatar';
import MemberCard from '../member-card';

const MemberSelectDialog: React.FC<MemberSelectDialogProps> = (props) => {
    const {
        renderName: renderNameBase,
        renderIcon: renderIconBase,
        renderTag: renderTagBase,
        ...otherProps
    } = props;

    const renderName: MemberSelectDialogProps['renderName'] = (member) => {
        if (renderNameBase) {
            return renderNameBase(member);
        }

        return <MemberName name={member.nickname} status={member.status} type={member.type} />;
    };

    const renderIcon: MemberSelectDialogProps['renderIcon'] = (member) => {
        if (renderIconBase) {
            return renderIconBase(member);
        }

        return (
            <MemberAvatar
                key={member._id}
                showViewCard
                memberId={member._id}
                img={member.avatar}
                name={member.nickname}
                status={member.status}
            />
        );
    };

    const renderTag: MemberSelectDialogProps['renderTag'] = (member, options) => {
        if (renderTagBase) {
            return renderTagBase(member, options);
        }

        return (
            <ValueTag
                valueKey={member._id}
                icon={
                    renderIconBase ? (
                        renderIconBase(member)
                    ) : (
                        <MemberAvatar
                            key={member._id}
                            memberId={member._id}
                            img={member.avatar}
                            name={member.nickname}
                            status={member.status}
                        />
                    )
                }
                name={renderName(member)}
                tagOptions={options}
                popoverOptions={{
                    content: <MemberCard memberId={member._id} />
                }}
            />
        );
    };

    return (
        <MemberSelectDialogBase
            allowSearch={!authModel.isISVEncrypted}
            renderName={renderName}
            renderIcon={renderIcon}
            renderTag={renderTag}
            onSearchKeywordChange={(keyword) => {
                tracker(TRACKER.MEMBER_SEARCH, {
                    p1: 'member',
                    p2: join(keyword, ',')
                });
            }}
            onSearchResultAllCheck={() => {
                tracker(TRACKER.MEMBER_SEARCH_RESULT_ALL_CHECK, {
                    p1: 'member'
                });
            }}
            onAllSelectedView={(count) => {
                tracker(TRACKER.MEMBER_VIEW_ALL_SELECTED, {
                    p1: 'member',
                    p2: count
                });
            }}
            onSelectWidthChange={(width) => {
                tracker(TRACKER.MEMBER_WIDTH_CHANGE, {
                    p1: 'member',
                    p2: width
                });
            }}
            {...otherProps}
        />
    );
};

export default MemberSelectDialog;
